import { RootState } from 'app/store';

export const selectMessages = (state: RootState) => state.inbox.messages;

export const selectLoadingMessages = (state: RootState) =>
  state.inbox.loadingMessages;

export const selectLoadingMessagesError = (state: RootState) =>
  state.inbox.loadingMessagesError;

export const selectTotalPageCount = (state: RootState) =>
  state.inbox.totalPageCount;

export const selectUnreadMessageCount = (state: RootState) =>
  state.inbox.unreadMessageCount;
